import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { convertToObj, removeDefaultParams } from '../../Utils/helper';
import { EffectAnchor } from './BannersGrid/styled';

export default function AnchorCoverTag(props) {
  const {
    url,
    cardEffect,
    hideInnerContentIfNoUrl,
    stopRedirection,
    callbackFunction,
    index,
    element,
    fragmentClass,
    newTab,
    showLandingPage,
  } = props;
  const router = useRouter();
  const value = element?.deeplinkValue?.toString();
  const queryInDeepLink = value?.split('?')[1] || '';
  let obj = {};
  if (queryInDeepLink) obj = convertToObj(queryInDeepLink);
  return (
    <>
      {url ? (
        <Link
          href={{
            pathname: url,
            query: removeDefaultParams({
              ...router.query,
              ...obj,
            }),
          }}
          locale={false}
          passHref
          prefetch={false}
          legacyBehavior
        >
          <EffectAnchor
            className={url ? cardEffect : ''}
            onClick={(e) => {
              if (stopRedirection) {
                e.preventDefault();
              }
              if (callbackFunction) {
                e.preventDefault();
                callbackFunction(index, url, element, e, obj, showLandingPage);
              }
            }}
            target={newTab ? '_blank' : '_self'}
          >
            {props.children}
          </EffectAnchor>
        </Link>
      ) : fragmentClass ? (
        <div className={fragmentClass}>
          {hideInnerContentIfNoUrl ? null : <>{props.children}</>}
        </div>
      ) : (
        <> {hideInnerContentIfNoUrl ? null : <>{props.children}</>}</>
      )}
    </>
  );
}
